<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="nextpara"> </p>
<p class="Book_Title_Book_NOTHING-S"><span class="CharOverride-1">Nothing’s</span></p>
<p class="Book_Title_Book_Wrong ParaOverride-1"><span class="CharOverride-2">wrong</span></p>
<p class="Book_Title_Book_Sub-title">A man’s guide to managin<span class="noBreak">g emotions</span></p>
<p class="Book_Title_Book_Author"> </p>
<p class="Book_Title_Book_Author">DA<span class="noBreak">VID KUNDTZ</span></p>
<p class="Book_Title_Conari-_logo"><img alt="" class="_idGenObjectAttribute-1" src="image/cplogo_titlepage.png"/></p>
<p class="Book_Title_Coral-Gables _idGenParaOverride-1">Coral <span class="noBreak">Gables, FL</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// NothingsWrong-1.vue?438576f6